import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form as AntForm, Input, Button } from "antd";
import { Editor } from "@tinymce/tinymce-react";
import { instance } from "utils/axios";

function ServiceForm() {
  const { id } = useParams();
  const [form] = AntForm.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isEdit = id != "new";
  const editorRef = useRef(null);
  useEffect(() => {
    if (isEdit) {
      instance({
        method: "get",
        url: `/service/${id}`,
      })
        .then((res) => {
          form.setFieldsValue(res.data);
        })
        .catch((err) => console.error(err));
    }
  }, [id, form]);

  const handleSubmit = (values) => {
    if (isEdit) {
      instance({
        method: "put",
        url: "/service", // API to update news
        data: { id, ...values },
      })
        .then(() => {
          navigate("/service");
        })
        .catch((err) => {})
        .finally(() => setLoading(false));
    } else {
      instance({
        method: "post",
        url: "/service", // API to create new news
        data: values,
      })
        .then(() => {
          //   handleCloseModal();
          navigate("/service");
        })
        .catch((err) => {})
        .finally(() => setLoading(false));
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-6 text-center">
          {isEdit ? "Үйлчилгээ засах" : "Шинэ үйлчилгээ нэмэх"}
        </h1>
        <AntForm
          form={form}
          layout="vertical"
          onFinish={(values) => {
            const content = editorRef.current?.getContent(); // Editor-оос шууд агуулгыг авах
            const processedValues = {
              ...values,
              content,
            };
            handleSubmit(processedValues);
          }}
          className="space-y-6"
        >
          <AntForm.Item
            name="name"
            label="Нэр"
            rules={[
              { required: true, message: "Үйлчилгээний нэрийг оруулна уу!" },
            ]}
          >
            <Input placeholder="Нэр" />
          </AntForm.Item>
          <AntForm.Item
            name="content"
            label="Агуулга"
            rules={[{ required: true, message: "Агуулга оруулна уу!" }]}
          >
        <Editor
  apiKey="7rwd2v6wih2u0iztpuojlwhwjkagfj548s43yccfvpuy0vir"
  onInit={(evt, editor) => (editorRef.current = editor)}
  init={{
    height: 500,
    menubar: true,
    plugins: [
      "advlist autolink lists link image charmap print preview anchor",
      "searchreplace visualblocks code fullscreen",
      "insertdatetime media table paste code help",
    ],
    toolbar:
      "undo redo | formatselect | bold italic backcolor | \
       alignleft aligncenter alignright alignjustify | \
       bullist numlist outdent indent | image table | removeformat | help",
    setup: (editor) => {
      // Add a custom button for the predefined layout
      editor.ui.registry.addButton("imageWithCheckboxes", {
        text: "Image + Checkboxes",
        onAction: () => {
          editor.insertContent(`
            <div style="display: flex; align-items: flex-start; gap: 20px; margin: 20px 0;">
              <!-- Left side: Image -->
              <div style="flex: 1; text-align: center;">
                <img
                  src="https://via.placeholder.com/400x300"
                  alt="рентген зураг"
                  style="width: 100%; border-radius: 8px; object-fit: contain;"
                />
                <p style="margin-top: 10px;">рентген зураг</p>
              </div>

              <!-- Right side: Checkboxes -->
              <div style="flex: 1;">
                <ul style="list-style-type: none; padding: 0; margin: 0;">
                  <li style="margin-bottom: 15px;">
                    <label>
                      <input type="checkbox" style="margin-right: 10px;" />
                      Цээжний рентген зураг
                    </label>
                  </li>
                  <li style="margin-bottom: 15px;">
                    <label>
                      <input type="checkbox" style="margin-right: 10px;" />
                      Хэвлийн тойм рентген зураг
                    </label>
                  </li>
                  <li style="margin-bottom: 15px;">
                    <label>
                      <input type="checkbox" style="margin-right: 10px;" />
                      Нурууны рентген зураг
                    </label>
                  </li>
                  <li style="margin-bottom: 15px;">
                    <label>
                      <input type="checkbox" style="margin-right: 10px;" />
                      Ууц, ахар сүүлний рентген зураг
                    </label>
                  </li>
                  <li style="margin-bottom: 15px;">
                    <label>
                      <input type="checkbox" style="margin-right: 10px;" />
                      Үе болон ясны рентген зураг
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          `);
        },
      });
    },
  }}
/>

          </AntForm.Item>
          <AntForm.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="w-full"
            >
              Хадгалах
            </Button>
          </AntForm.Item>
        </AntForm>
      </div>
    </div>
  );
}

export default ServiceForm;
